<template>
  <div>
    <v-form
      v-if="!isCurriculumStored"
      v-model="valid"
    >
      <base-info-card
        :title="title"
        :subtitle="subtitle"
        space="4"
        color="primary"
      />

      <base-text-field
        v-model="name"
        label="Nombre"
        maxlength="20"
        :rules="nameRules"
        required
      />

      <base-text-field
        v-model="tlf"
        label="Teléfono"
        type="number"
        maxlength="9"
        :rules="phoneRules"
        required
      />

      <base-text-field
        v-model="email"
        label="Email"
        maxlength="60"
        :rules="emailRules"
        required
      />

      <base-text-field
        v-model="cp"
        label="Código Postal"
        maxlength="6"
        required
      />

      <base-textarea
        v-model="body"
        class="mb-6"
        label="Carta de Presentación"
      />

      <v-file-input
        v-model="files"
        :rules="rules"
        accept="application/pdf, .doc, .docx, application/msword, image/png, image/jpeg, image/bmp"
        placeholder="Adjunta tu curriculum"
        label="Mi Curruculum"
        prepend-icon="mdi-paperclip"
      >
        <template #selection="{ text }">
          <v-chip
            small
            label
            color="primary"
          >
            {{ text }}
          </v-chip>
        </template>
      </v-file-input>

      <p v-html="lopd" />

      <v-checkbox
        v-model="lopdCheck"
        label="Entendido y acepto las condiciones detalladas en el párrafo anterior relativas a la LOPD"
      />

      <div class="vue-recaptcha">
        <vue-recaptcha
          ref="recaptcha"
          class="mb-3"
          :sitekey="sitekey"
          @verify="onVerify"
          @expired="onExpired"
        />
      </div>
      <base-btn
        :disabled="!lopdCheck || !valid || !isHuman"
        :color="!theme.isDark ? 'accent' : 'white'"
        outlined
        @click.stop="sendCurriculum"
      >
        Enviar Curriculum
      </base-btn>

      <!-- <base-btn
        :disabled="!lopdCheck || !valid"
        :color="!theme.isDark ? 'accent' : 'white'"
        :href="dataMail"
        outlined
        target="_blank"
      >
        Enviar Curriculum
      </base-btn> -->
    </v-form>
    <v-alert
      v-else
      text
      color="primary"
    >
      <h3 class="headline">
        Currículum Recibido!
      </h3>
      <div>
        Gracias por tu interés en formar parte de nuestro equipo.<br>
        Tu solicitud ha sido enviada con éxito. Próximamente nos podremos en contacto contigo para informarte sobre el estado de la misma.
      </div>

      <v-divider
        class="my-4 info"
        style="opacity: 0.22"
      />
    </v-alert>
  </div>
</template>

<script>
  // import VueRecaptcha from 'vue-recaptcha'
  // Mixins
  import reCaptcha from '@/mixins/reCaptcha'
  export default {
    name: 'BaseContactForm',

    /* components: {
      'vue-recaptcha': VueRecaptcha,
    }, */

    mixins: [
      reCaptcha,
    ],

    // Injected from the Vuetify Themeable mixin
    inject: ['theme'],

    props: {
      subtitle: {
        type: String,
        default: 'No olvides adjuntar tu curriculum, a ser posible en formarto PDF',
      },
      title: {
        type: String,
        default: 'ENVÍANOS TU CURRICULUM',
      },
      referencia: {
        type: String,
        default: 'bolsa-empleo-general',
      },
    },

    data: () => ({
      valid: false,
      files: [],
      rules: [
        value => (value && value.size < 2048000) || 'Se requiere un archivo y su tamaño máximo NO debe superar los 2 MB!',
      ],
      email: '',
      name: '',
      body: '',
      tlf: '',
      cp: '',
      lopdCheck: false,
      lopd: 'De conformidad con lo establecido en la normativa vigente en Protección de Datos de Carácter Personal, le informamos que sus datos serán incorporados al sistema de tratamiento titularidad de PROYECTOS E INSTALACIONES ROSMAR S.L. con CIF B91467522 y domicilio social sito en AVDA. DE BOLLULLOS DE LA MITACIÓN 1 (PIBO), 41110 - BOLLULLOS DE LA MITACIÓN (SEVILLA), con la finalidad de atender sus consultas, remitirle información relacionada que pueda ser de su interés y/o formar parte en los procesos de selección de personal que se lleven a cabo por nuestra parte, así como envío de comunicaciones comerciales y promocionales. En cumplimiento con la normativa vigente, PROYECTOS E INSTALACIONES ROSMAR S.L. informa que los datos serán conservados durante el plazo estrictamente necesario para cumplir con los preceptos mencionados con anterioridad. De acuerdo con los derechos que le confiere la normativa vigente en protección de datos podrá ejercer los derechos de acceso, rectificación, limitación de tratamiento, supresión, portabilidad y oposición al tratamiento de sus datos de carácter personal así como del consentimiento prestado para el tratamiento de los mismos, dirigiendo su petición a la dirección postal indicada más arriba o al correo electrónico administracion@rosmarsl.es.',
    }),

    computed: {
      isCurriculumStored () {
        return this.$store.getters.curriculumStored
      },

      dataMail () {
        return `mailto:administracion@rosmarsl.es?subject=Curriculum ref.: ${this.referencia} / Tlf.: ${this.tlf || '-'} / C.P.: ${this.cp || '-'}&from=${this.name} <${this.email}>&body=${this.body}`
      },

      nameRules () {
        return [
          v => !!v || 'Campo requerido',
          v => v.length <= 20 || 'No se admiten más de 20 caracteres',
        ]
      },

      emailRules () {
        return [
          v => !!v || 'Campo requerido',
          v => /.+@.+/.test(v) || 'Escribe un email válido',
        ]
      },

      phoneRules () {
        return [
          v => !!v || 'Campo requerido',
          v => v.length === 9 || 'Escribe un número de 9 caracteres',
          v => /^[679]{1}[0-9]{8}$/.test(v.toString().replace(/\s/g, '')) || 'Escribe un email válido',
        ]
      },
    },

    watch: {
      isCurriculumStored (newValue) {
        if (newValue) {
          this.resetForm()
        }
      },
    },

    mounted () {
      this.resetRecaptcha()
    },

    methods: {
      resetForm () {
        this.name = ''
        this.email = ''
        this.tlf = ''
        this.cp = ''
        this.body = ''
        this.lopdCheck = false
        this.valid = true
        this.resetRecaptcha()
      },

      sendCurriculum () {
        if (!this.files || !this.isHuman) {
          console.error('Falta el archivo adjunto')
          return
        }
        const datos = {
          file: this.files,
          name: this.name,
          email: this.email,
          tlf: this.tlf,
          cp: this.cp,
          presenta: this.body,
          referencia: this.referencia,
          isHuman: this.isHuman,
        }
        this.$store.dispatch('sendCurriculum', datos)
      },
    },
  }
</script>
